import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

// Schema
import MainApiService from "../../../../../services/mainApi.service";
import {
  FormContainer,
  FormInput,
  SwitchInput,
  useFetch,
} from "@4uhub/lib4uhub";
import {
  listClassificationSchema,
  TListClassificationForm,
} from "./listClassificationSchema";
import FormInformationCode from "./FormInformationCode/FormInformationCode";

const LIST_CLASSIFICATION_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/ListClassification/";
const listClassificationService = new MainApiService<TListClassificationForm>(
  LIST_CLASSIFICATION_ROUTE
);

const translationPath = "page.4uDlist.listClassification.";

const ListClassification = () => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(
    listClassificationService.create
  );

  const { sendRequest: update, loading: uLoading } = useFetch(
    listClassificationService.updateItemById
  );
  const { sendRequest: get, loading: gLoading } = useFetch(
    listClassificationService.getItemById
  );

  const updateHandler = (v: TListClassificationForm, id: string) =>
    update({ item: v, id: id });

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TListClassificationForm>
      saveFunction={save}
      updateFunction={updateHandler}
      getFunction={get}
      loading={loading}
      title={t(translationPath + "list_classification")}
      schema={listClassificationSchema}
      subtitle={t(translationPath + "new")}
      subtitleWatchField={"name"}
      fields={(type) => (
        <Grid container spacing={2}>
          {type !== "create" && (
            <Grid
              item
              xs={6}
              sx={{ display: "flex", justifyContent: "flex-start" }}
            >
              <FormInformationCode />
            </Grid>
          )}
          <Grid
            item
            xs={type !== "create" ? 6 : 12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <SwitchInput
              name="enable"
              label={t(translationPath + "enable") || "Enable"}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormInput
              size="small"
              name="name"
              fullWidth
              label={t(translationPath + "name") || "Name"}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormInput
              size="small"
              name="description"
              fullWidth
              multiline
              minRows={4}
              label={t(translationPath + "description") || "Description"}
            />
          </Grid>
        </Grid>
      )}
    />
  );
};

export default ListClassification;
